export const DeliveryTypeEndpoints = {
  LIST: '/api/admin/deliveryTypes',
  GET: '/api/admin/deliveryTypes/:id',
  UPDATE: '/api/admin/deliveryTypes/:id',
};
